/* OPENLIQUID — PDP enhancement: AJAX add-to-cart (opens Horizon cart drawer)
 * + mobile sticky ATC bar. Applies to all oq_fullpdp templates (forms .oqp__buy).
 * Deployed via src/scripts/qw1-cart-drawer-sticky.mjs — do not edit in theme directly. */
(() => {
  if (window.__olPdpAtc) return;
  window.__olPdpAtc = true;

  const init = () => {
    const forms = [...document.querySelectorAll('form.oqp__buy[action*="/cart/add"]')];
    if (!forms.length) return;

    const sectionIds = () =>
      [...document.querySelectorAll('cart-items-component')]
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

    async function ajaxAdd(form, btn) {
      const fd = new FormData(form);
      const ids = sectionIds();
      if (ids.length) fd.append('sections', ids.join(','));
      const orig = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt…';
      }
      try {
        const res = await fetch('/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        });
        const json = await res.json();
        if (json.status) throw new Error(json.message || 'Cart error');

        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: {},
          sourceId: form.id || 'ol-pdp-atc',
          data: {
            source: 'product-form-component',
            itemCount: Number(fd.get('quantity')) || 1,
            productId: String(json.product_id || ''),
            variantId: String(fd.get('id') || ''),
            sections: json.sections || {},
          },
        };
        document.dispatchEvent(ev);

        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) {
          drawer.open();
        }
        if (btn) {
          btn.textContent = '✓ Hinzugefügt';
          setTimeout(() => {
            btn.textContent = orig;
            btn.disabled = false;
          }, 1500);
        }
      } catch (e) {
        if (btn) {
          btn.textContent = orig;
          btn.disabled = false;
        }
        form.submit(); // Fallback: klassischer Submit → /cart
      }
    }

    forms.forEach((form) => {
      form.addEventListener('submit', (ev) => {
        ev.preventDefault();
        ajaxAdd(form, form.querySelector('.oqp__atc'));
      });
    });

    // --- Sticky ATC bar (mobile) ---
    const buyForm = forms[0];
    const title = document.querySelector('.oqp__h1')?.textContent?.trim() || document.title;
    const price = document.querySelector('.oqp__now')?.textContent?.trim() || '';

    const bar = document.createElement('div');
    bar.className = 'ol-sticky-atc';
    bar.innerHTML =
      '<div class="ol-sticky-atc__info"><div class="ol-sticky-atc__title"></div><div class="ol-sticky-atc__price"></div></div>' +
      '<button type="button" class="ol-sticky-atc__btn">In den Warenkorb</button>';
    bar.querySelector('.ol-sticky-atc__title').textContent = title;
    bar.querySelector('.ol-sticky-atc__price').textContent = price;
    document.body.appendChild(bar);

    bar.querySelector('button').addEventListener('click', () => {
      ajaxAdd(buyForm, bar.querySelector('button'));
    });

    const io = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
      },
      { threshold: 0 }
    );
    io.observe(buyForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
